import { Lesson } from '@/plugins/api'
import { Class } from '../../plugins/api'
export default {
  namespaced: true,
  state: {
    timeTable: [],
    lessons: [],
  },
  actions: {
    async fetchLessons({ commit }, params) {
      const res = await Lesson.fetch(params)
      commit('setLesson', res)
      return res
    },
    async updateLesson(_, data) {
      const res = await Class.updateLesson(data)
      return res
    },
    async updateTeachers(_, { id, params }) {
      const res = await Lesson.updateTeachers(id, params)
      return res
    },
    async deleteLesson({ commit }, id) {
      await Lesson.remove(id)
      commit('removeLesson', id)
    },
  },
  mutations: {
    setLessons(state, payload) {
      state.lessons = payload
    },
    setLesson(state, data) {
      state.lessons = data
    },
    removeLesson(state, id) {
      state.lessons = state.lessons.filter(lesson => lesson.id !== id)
    },
  },
}
